module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/plugins-313.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/vux-loader/plugins.md
// module id = 781
// module chunks = 412